var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0002 8.5H9.66683V9.83333H11.0002M11.0002 5.83333H9.66683V7.16667H11.0002M12.3335 11.1667H7.00016V9.83333H8.3335V8.5H7.00016V7.16667H8.3335V5.83333H7.00016V4.5H12.3335M5.66683 3.16667H4.3335V1.83333H5.66683M5.66683 5.83333H4.3335V4.5H5.66683M5.66683 8.5H4.3335V7.16667H5.66683M5.66683 11.1667H4.3335V9.83333H5.66683M3.00016 3.16667H1.66683V1.83333H3.00016M3.00016 5.83333H1.66683V4.5H3.00016M3.00016 8.5H1.66683V7.16667H3.00016M3.00016 11.1667H1.66683V9.83333H3.00016M7.00016 3.16667V0.5H0.333496V12.5H13.6668V3.16667H7.00016Z",
    fill: "#BABABA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.b6c0fe6afaee6df99dad3cb4aed41c4c.svg";
export { ForwardRef as ReactComponent };